export default "__VITE_ASSET__xSUukync__"